export default __webpack_public_path__ + "static/NeffSans-Bold-2a1e0b27aa4bb2f554b4fb79eb670556.woff2";